/*! angular-dimple - 2.0.1 - 2015-03-18
*   https://github.com/esripdx/angular-dimple
*   Licensed ISC
*   forked to prefix directives */
(function(){
'use strict';
angular.module('angular-dimple', [
  'angular-dimple.graph',
  'angular-dimple.legend',
  'angular-dimple.x',
  'angular-dimple.y',
  'angular-dimple.scaledColor',
  'angular-dimple.r',
  'angular-dimple.line',
  'angular-dimple.bar',
  'angular-dimple.stacked-bar',
  'angular-dimple.area',
  'angular-dimple.stacked-area',
  'angular-dimple.scatter-plot',
  'angular-dimple.ring'
])

.constant('MODULE_VERSION', '0.0.1')

.value('defaults', {
  foo: 'bar'
});
angular.module('angular-dimple.area', [])

.directive('dimpleArea', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleArea', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var areaController = $controllers[0];
      var chart = graphController.getChart();

      function addArea () {
        var area;
        if ($attrs.value) {
          area = chart.addSeries([$attrs.field], dimple.plot.area);
          graphController.filter($attrs);
          area.lineMarkers = true;
        } else {
          var values = dimple.getUniqueValues($scope.data, $attrs.field);
          angular.forEach(values, function(value){
            area = chart.addSeries([$attrs.field], dimple.plot.area);
            graphController.filter($attrs);
            area.lineMarkers = true;
          });
        }
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addArea();
        }
      });
    }
  };
}]);


angular.module('angular-dimple.bar', [])

.directive('dimpleBar', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleBar', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var lineController = $controllers[0];
      var chart = graphController.getChart();

      function appendText (svg, rect, textYPosition, textToAppend, textAnchor, xOffset) {
        textAnchor = textAnchor || "middle";
        var x = xOffset > 0 ? xOffset
          : (textAnchor === "middle" ? rect.x + rect.width / 2
            : (textAnchor === "end" ? (rect.x + rect.width - 6) : rect.x + 6));
        svg.append("text")
        // Position in the centre of the shape (vertical position is
        // manually set due to cross-browser problems with baseline)
          .attr("x", x)
          .attr("y", rect.y + textYPosition)
          // Centre align
          .style("text-anchor", textAnchor || "middle")
          .style("font-size", "10px")
          .style("font-family", "sans-serif")
          // Make it a little transparent to tone down the black
          .style("opacity", 0.6)
          // Prevent text cursor on hover and allow tooltips
          .style("pointer-events", "none")
          // Format the number
          .text(textToAppend);
      }

      function addBar () {
        var filteredData;
        var bar = chart.addSeries([$attrs.field], dimple.plot.bar);

        if ($scope.dimpleClick) {
          bar.addEventHandler('click', function(e) {
            $scope.dimpleClick(e);
          });
        }

        if ($attrs && $attrs.showLabels && $attrs.showLabels === 'true') {
          bar.afterDraw = function(shape, data) {
              // Get the shape as a d3 selection
            var s = d3.select(shape),
                rect = {
                  x: parseFloat(s.attr("x")),
                  y: parseFloat(s.attr("y")),
                  width: parseFloat(s.attr("width")),
                  height: parseFloat(s.attr("height"))
                };
            // Add a text label for the value
            var isHorizontal = $attrs.isHorizontal && $attrs.isHorizontal === 'true';
            var offset = 14;
            var textAnchor = $attrs.textAnchor || "middle";
            var barData = _.find(this.chart.data, function (d) {
              return d && d.Label && d.Label.length > 0 && (d.Label[0] === data.cx || d.Label[0] === data.cy);
            });

            var xOffset = 0;
            var yOffset = 0;
            if (isHorizontal) {
              yOffset = 0 - offset;
              if (rect.width < 40) {
                var anchorOffset = textAnchor === "middle" ? 25
                  : (textAnchor === "end" ? 45 : 5);
                xOffset = rect.x + rect.width + anchorOffset;
              }
            } else {
              var requiredHeight = offset;
              if (barData) {
                requiredHeight = offset * barData.Label.length;
              }

              if (requiredHeight > rect.height) {
                yOffset = 0 - requiredHeight - 8;
              }
            }

            // the label from the data provided
            appendText(this.chart.svg, rect, yOffset + offset, data.yValue, textAnchor, xOffset);
            if (barData) {
              // skip the first item as it's a key
              for (var ldi = 1; ldi < barData.Label.length; ldi++) {
                appendText(this.chart.svg, rect, yOffset + (offset * (ldi + 1)), barData.Label[ldi], textAnchor, xOffset);
              }
            }
          };
        }

        graphController.filter($attrs);
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addBar();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.graph', [])

.directive('dimpleGraph', ['$timeout', function ($timeout) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      data: '=',
      color: '=',
      dimpleClick: '=',
      overrideTooltip: '=',
      overrideMin: '=',
      overrideMax: '=',
      wrapXLabels: '=',
      barColorOverride: '=',
      onTooltip: '='
    },
    require: ['dimpleGraph'],
    transclude: true,
    link: function (scope, element, attrs, controllers, transclude) {
      var graphController = controllers[0];
      graphController._createChart();
      scope.dataReady = false;
      scope.filters = [];

      var chart = graphController.getChart();
      var transition;
      if (attrs.transition) {
        transition = attrs.transition;
      } else {
        transition = 750;
      }

      var hideOutOfRangeValues = function (chart) {
        if (_.isUndefined(scope.overrideMin) && _.isUndefined(scope.overrideMax)) {
          return;
        }

        _.each(chart.series, function (series) {
            series.shapes.style('opacity', function (d) {
              var hideElement = false;
              var elementValue = d.y;

              if (!_.isUndefined(scope.overrideMin) && (elementValue < scope.overrideMin)) {
                hideElement = true;
              }

              if (!_.isUndefined(scope.overrideMax) && (scope.overrideMax < elementValue)) {
                hideElement = true;
              }

              return (hideElement ? 0 : 0.8);
            });
        });
      };

      var wrapXLabels = function (chart) {
        if (!scope.wrapXLabels) { return; }

        var tickWidth = 1000;

        // see [Wrapping Long Labels](http://bl.ocks.org/mbostock/7555321#index.html)
        var insertLinebreaks = function (d) {
          var rect = this.getBBox();
          var middleX = (rect.width / 2);
          var origMiddle = rect.x + middleX;

          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1, // ems
              y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", origMiddle).attr("y", y).attr("dy", dy + "em");

          while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > tickWidth) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", origMiddle).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            }
          }
        }

        _.each(chart.axes, function (axis) {
          if ("x" === axis.position) {
            var numTicks = axis.shapes.selectAll('.tick')[0].length;
            var axisWidth = axis.shapes[0][0].getBBox().width;
            tickWidth = axisWidth / numTicks;

            axis.shapes.selectAll('text').each(insertLinebreaks);
          }
        });
      };

      var setChartColors = function (chart) {
        if (scope.barColorOverride) {
          _.forOwn(scope.barColorOverride, function (hexColor, key) {
            chart.assignColor(key, hexColor);
          });
        }
      };

      scope.$watch('data', function(newValue, oldValue) {
        if (newValue) {
          scope.dataReady = true;
          graphController.setData();
          setChartColors(chart);

          chart.draw(transition);

          $timeout(function () {
            hideOutOfRangeValues(chart);
            wrapXLabels(chart);
          }, 10 + transition);
        }
      });

      transclude(scope, function(clone){
        element.append(clone);
      });
    },
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
      var chart;

      var id = (Math.random() * 1e9).toString(36).replace(".", "_");
      $element.append('<div class="dimple-graph" id="dng-'+ id +'"></div>');

      this._createChart = function () {
        // create an svg element

        var width = $attrs.width ? $attrs.width : '100%';
        var height = $attrs.height ? $attrs.height : '100%';

        var svg = dimple.newSvg('#dng-'+ id +'', width, height);
        var data = $scope.data;

        // create the dimple chart using the d3 selection of our <svg> element
        chart = new dimple.chart(svg, data);

        if ($attrs.margin) {
          var margins = $attrs.margin;
          if (margins.length !== 4) {
              margins = $attrs.margin.split("|");
              switch (margins.length) {
                  case 3:
                    margins.push("0");
                    break;
                  case 2:
                    margins.push(margins[0]);
                    margins.push(margins[1]);
                    break;
                  case 1:
                      margins.push(margins[0]);
                      margins.push(margins[0]);
                      margins.push(margins[0]);
                    break;
              }
          }
          chart.setMargins(margins[0].trim(), margins[1].trim(), margins[2].trim(), margins[3].trim());
        } else {
          var marginLeft = 60;
          if ($attrs.dimpleMarginLeft) {
            marginLeft = $attrs.dimpleMarginLeft;
          }
          chart.setMargins(marginLeft, 60, 20, 40);
        }

        // auto style
        var autoStyle = $attrs.autoStyle === 'false' ? true : false;
        chart.noFormats = autoStyle;

        // Apply palette styles
        if ($attrs.color) {
          var palette = $scope.color;
          for (var i = 0; i < palette.length; i++ ) {
            chart.assignColor(palette[i].name, palette[i].fill, palette[i].stroke, palette[i].opacity);
          }
        }

        if ($attrs.defaultColor) {
          chart.defaultColors = [
            new dimple.color($attrs.defaultColor)
          ];
        }
      };


      this.getChart = function () {
        return chart;
      };

      this.setData = function () {
        chart.data = $scope.data;
      };

      this.draw = function () {
        chart.draw();
      };

      this.getID = function () {
        return id;
      };

      this.filter = function (attrs) {
        if (attrs.value !== undefined) {
          $scope.filters.push(attrs.value);
        }
        if ($scope.filters.length) {
          chart.data = dimple.filterData($scope.data, attrs.field, $scope.filters);
        }

        if (attrs.filter !== undefined) {
          var thisFilter = attrs.filter.split(':');
          var field = thisFilter[0];
          var value = [thisFilter[1]];
          chart.data = dimple.filterData($scope.data, field, value);
        }
      };

    }]
  };
}]);
angular.module('angular-dimple.legend', [])

.directive('dimpleGraphLegend', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleGraphLegend', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addLegend () {
        var left = $attrs.left ? $attrs.left : "10%";
        var top = $attrs.top ? $attrs.top : "4%";
        var height = $attrs.height ? $attrs.height : "10%";
        var width = $attrs.width ? $attrs.width : "90%";
        var position = $attrs.position ? $attrs.position : 'left';
        chart.addLegend(left, top, width, height, position);
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addLegend();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.line', [])

.directive('dimpleLine', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleLine', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();
      var drawn = false;

      function addLine () {
        var filteredData;
        var line = chart.addSeries([$attrs.field], dimple.plot.line);
        graphController.filter($attrs);
        line.lineMarkers = true;
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addLine();
        }
      });

    }
  };
}]);
angular.module('angular-dimple.r', [])

.directive('dimpleR', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleR', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        var r = chart.addMeasureAxis('p', $attrs.field);

        if ($attrs.title && $attrs.title !== "null") {
          r.title = $attrs.title;
        } else if ($attrs.title == "null") {
          r.title = null;
        }
      }

      $scope.$watch('data', function(newValue, oldValue) {
        if (newValue) {
          addAxis();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.ring', [])

.directive('dimpleRing', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleRing', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var areaController = $controllers[0];
      var chart = graphController.getChart();

      function setData (data, series) {
        series.data = data;
      }

      function addRing () {
        var thickness;
        var ring = chart.addSeries([$attrs.field], dimple.plot.pie);
        if ($attrs.thickness && !$attrs.diameter) {
          thickness = (100 - $attrs.thickness) + '%';
          ring.innerRadius = thickness;
        } else if ($attrs.thickness && $attrs.diameter) {
          thickness = ($attrs.diameter - $attrs.thickness) + '%';
          ring.innerRadius = thickness;
        } else {
          ring.innerRadius = "50%";
        }

        if ($attrs.diameter) {
          ring.outerRadius = ($attrs.diameter) + '%';
        }
        graphController.filter($attrs);
        graphController.draw();
      }

      $scope.$watch('data', function(newValue, oldValue) {
        if (newValue) {
          addRing();
        }
      });
    }
  };
}]);


angular.module('angular-dimple.scatter-plot', [])

.directive('dimpleScatterPlot', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleScatterPlot', '^dimpleGraph'],
    controller: [function() {}],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addScatterPlot () {
        if ($attrs.dotSizeScaler) {
          var z = chart.addMeasureAxis('z', $attrs.dotSizeScaler);
          z.overrideMin = 0;
          z.overrideMax = 100;
        }

        var array = [];

        if ($attrs.series){ array.push($attrs.series); }
        array.push($attrs.field);
        if ($attrs.label || $attrs.label === '') { array.push($attrs.label); }
        var scatterPlot = chart.addSeries(array, dimple.plot.bubble);
        scatterPlot.aggregate = dimple.aggregateMethod.avg;
        graphController.filter($attrs);
        graphController.draw();

        if ($scope.overrideTooltip) {
          scatterPlot.getTooltipText = function (e) {
            return $scope.overrideTooltip(e);
          }
        }
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addScatterPlot();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.stacked-area', [])

.directive('dimpleStackedArea', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleStackedArea', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var areaController = $controllers[0];
      var chart = graphController.getChart();

      function addArea () {
        var area;
        if ($attrs.series) {
          area = chart.addSeries([$attrs.series], dimple.plot.area);
        } else {
          area = chart.addSeries([$attrs.field], dimple.plot.area);
        }
        graphController.filter($attrs);
        area.lineMarkers = false;
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addArea();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.stacked-bar', [])

.directive('dimpleStackedBar', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleStackedBar', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var lineController = $controllers[0];
      var chart = graphController.getChart();

      function addBar () {
        var bar;
        if ($attrs.series) {
          bar = chart.addSeries([$attrs.series], dimple.plot.bar);
        } else {
          bar = chart.addSeries([$attrs.field], dimple.plot.bar);
        }

        if ($attrs.orderBy) {
          bar.addOrderRule($attrs.orderBy);
        } else if ($attrs.orderByDesc) {
          bar.addOrderRule($attrs.orderByDesc, true);
        }

        if ($scope.onTooltip) {
          bar.getTooltipText = function(e) { return $scope.onTooltip(e) };
        }

        if ($scope.dimpleClick) {
          bar.addEventHandler('click', function(e) {
            $scope.dimpleClick(e);
          });
        }

        graphController.filter($attrs);
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addBar();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.x', [])

.directive('dimpleX', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleX', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        var x;
        if ($attrs.groupBy) {
          if ($attrs.type == 'Measure') {
            x = chart.addMeasureAxis('x', [$attrs.groupBy, $attrs.field]);
          } else if ($attrs.type == 'Percent') {
            x = chart.addPctAxis('x', $attrs.field);
          } else if ($attrs.type == 'Time') {
            x = chart.addTimeAxis('x', $attrs.field);
            if ($attrs.format) {
              x.tickFormat = $attrs.format;
            }
          } else {
            x = chart.addCategoryAxis('x', [$attrs.groupBy, $attrs.field]);
          }
          if ($attrs.orderBy) {
            x.addGroupOrderRule($attrs.orderBy);
          }
          if ($attrs.orderByDesc) {
            x.addGroupOrderRule($attrs.orderByDesc, true);
          }
        } else {
          if ($attrs.type == 'Measure') {
            x = chart.addMeasureAxis('x', $attrs.field);
          } else if ($attrs.type == 'Percent') {
            x = chart.addPctAxis('x', $attrs.field);
          } else if ($attrs.type == 'Time') {
            x = chart.addTimeAxis('x', $attrs.field);
            if ($attrs.format) {
              x.tickFormat = $attrs.format;
            }
          } else {
            x = chart.addCategoryAxis('x', $attrs.field);
          }

          if ($attrs.orderBy) {
            if ($attrs.orderWithData) {
              var orderArray = _.chain($scope.data).sortBy($attrs.orderBy).map($attrs.field).value();
              x.addOrderRule(orderArray);
            } else {
              x.addOrderRule($attrs.orderBy);
            }
          }
          if ($attrs.orderByDesc) {
            x.addOrderRule($attrs.orderByDesc, true);
          }
        }

        if ($attrs.title && $attrs.title !== "null") {
          x.title = $attrs.title;
        } else if ($attrs.title == "null") {
          x.title = null;
        }

        if ($attrs.fontSize) {
          x.fontSize = $attrs.fontSize;
        }

        if ($scope.wrapXLabels) {
          x.autoRotateLabel = false;
        }

        if ($attrs.showGridlines) {
          x.showGridlines = true;
        }
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addAxis();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.y', [])

.directive('dimpleY', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleY', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        var y;
        if ($attrs.groupBy) {
          if ($attrs.type == 'Category') {
            y = chart.addCategoryAxis('y', $attrs.field);
          } else if ($attrs.type == 'Percent') {
            y = chart.addPctAxis('y', $attrs.field);
          } else if ($attrs.type == 'Time') {
            y = chart.addTimeAxis('y', $attrs.field);
            if ($attrs.format) {
              y.tickFormat = $attrs.format;
            }
          } else {
            y = chart.addMeasureAxis('y', $attrs.field);
          }
          if ($attrs.orderBy) {
            y.addGroupOrderRule($attrs.orderBy);
          }
        } else {
          if ($attrs.type == 'Category') {
            y = chart.addCategoryAxis('y', $attrs.field);
          } else if ($attrs.type == 'Percent') {
            y = chart.addPctAxis('y', $attrs.field);
          } else if ($attrs.type == 'Time') {
            y = chart.addTimeAxis('y', $attrs.field);
            if ($attrs.format) {
              y.tickFormat = $attrs.format;
            }
          } else {
            y = chart.addMeasureAxis('y', $attrs.field);
          }
          if ($attrs.orderBy) {
            y.addOrderRule($attrs.orderBy);
          }
        }

        if ($attrs.title && $attrs.title !== "null") {
          y.title = $attrs.title;
        } else if ($attrs.title == "null") {
          y.title = null;
        }

        if ($scope.overrideMin) {
          y.overrideMin = $scope.overrideMin;
        }
        if ($scope.overrideMax) {
          y.overrideMax = $scope.overrideMax;
        }

        if ($attrs.fontSize) {
          y.fontSize = $attrs.fontSize;
        }

        if ($attrs.showGridlines) {
          y.showGridlines = true;
        }
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addAxis();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.scaledColor', [])

.directive('dimpleScaledColor', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleScaledColor', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        chart.addColorAxis($attrs.field);
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addAxis();
        }
      });
    }
  };
}]);
})();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/angular-dimple/angular-dimple.js
// module id = 1057
// module chunks = 0